import { FeaturesNames } from '@/shared/types/settings'

/** Имена featureable-компонентов (раньше keyof из legacy Featureable map). */
export type FeatureableComponents = string

export type UserFeaturesComponentRestrictions = 'Hide' | 'Disabled'

// Сопоставление компонентов с типом ограничения на отображение или действие
export const restrictionsMap = new Map<FeatureableComponents, UserFeaturesComponentRestrictions>([
  ['ChatFooter', 'Hide'],
  ['AlarmClock', 'Hide'],
  ['VoiceMail', 'Hide'],
  ['IVR', 'Hide'],
  ['FollowMe', 'Hide'],
  ['BlackWhiteList', 'Hide'],
  ['SubscriberAliases', 'Hide'],
  ['ASideMenuSettings', 'Hide'],
  ['ChatSettings', 'Hide'],
  ['HandleServicesPackages', 'Hide'],
  ['ServicesHandle', 'Hide'],
  ['AudiofilesManagement', 'Hide'],
  ['FunctionalKeysSetup', 'Hide'],
  ['IncomingCallHandling', 'Hide'],
  ['WebCallBackorder', 'Hide'],
  ['SpeedDial', 'Hide'],
  ['SubscriberPickUp', 'Hide'],
  ['VoiceMailForwarding', 'Hide'],
  ['CLIR', 'Hide'],
  ['LeaveMessageInput', 'Hide'],
  ['VoiceMailLink', 'Hide'],
  ['ChatFilesDragAndDrop', 'Hide'],
  ['ChatFilesUploadButton', 'Hide'],
  ['SetDND', 'Hide'],
  ['DesktopApplicationSettings', 'Hide'],
  ['Transfer', 'Hide'],
  ['Hold', 'Hide'],
])
// Сопоставление компонентов с юзер фичами
export const componentsFeaturesMap = new Map<FeatureableComponents, FeaturesNames[]>([
  ['ChatFooter', [FeaturesNames.INSTANT_MESSAGING]],
  ['AlarmClock', [FeaturesNames.ALARM]],
  ['VoiceMail', [FeaturesNames.VOICE_MAILBOX_ACCESS]],
  ['IVR', [FeaturesNames.IVR]],
  ['DesktopApplicationSettings', [FeaturesNames.DEFAULT]],
  ['FollowMe', [FeaturesNames.FOLLOW_ME]],
  ['BlackWhiteList', [FeaturesNames.BLACK_WHITE_LIST]],
  ['SubscriberAliases', [FeaturesNames.DEFAULT]],
  ['HandleServicesPackages', [FeaturesNames.ACCESS_GROUP_MANAGEMENT]],
  ['ServicesHandle', [FeaturesNames.DEFAULT]],
  ['ChatSettings', [FeaturesNames.INSTANT_MESSAGING]],
  ['AudiofilesManagement', [FeaturesNames.AUDIO_FILES_MANAGEMENT]],
  ['FunctionalKeysSetup', [FeaturesNames.BLF]],
  ['IncomingCallHandling', [FeaturesNames.FORWARD]],
  ['WebCallBackorder', [FeaturesNames.WEB_CALL_BACKORDER]],
  ['SpeedDial', [FeaturesNames.SPEED_DIAL]],
  ['SubscriberPickUp', [FeaturesNames.SUBSCRIBER_PICKUP]],
  ['VoiceMailForwarding', [FeaturesNames.VOICEMAIL_FORWARDING]],
  ['CLIR', [FeaturesNames.CLIR]],
  ['LeaveMessageInput', [FeaturesNames.INSTANT_MESSAGING]],
  ['VoiceMailLink', [FeaturesNames.VOICE_MAILBOX_ACCESS]],
  ['ChatFilesDragAndDrop', [FeaturesNames.WEBCLIENT_FILES]],
  ['ChatFilesUploadButton', [FeaturesNames.WEBCLIENT_FILES]],
  ['SetDND', [FeaturesNames.DO_NOT_DISTURB, FeaturesNames.FORWARD]],
  ['Transfer', [FeaturesNames.TRANSFER]],
  ['Hold', [FeaturesNames.HOLD]],
])
